import React, { useState } from "react";
import { useNavigate, Link, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { Wheat } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { apiError } from "@/lib/api";

export default function Login() {
  const [params] = useSearchParams();
  const [mode, setMode] = useState(params.get("mode") === "register" ? "register" : "login");
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [busy, setBusy] = useState(false);
  const { login, register } = useAuth();
  const navigate = useNavigate();
  const redirect = params.get("redirect") || "/account";

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const u = mode === "login"
        ? await login(form.email, form.password)
        : await register(form.name, form.email, form.password);
      toast.success(`أهلاً ${u.name}`);
      navigate(u.role === "admin" ? "/admin" : redirect);
    } catch (err) {
      toast.error(apiError(err.response?.data?.detail) || "تعذّر تسجيل الدخول");
    } finally { setBusy(false); }
  };

  return (
    <div className="flex min-h-screen items-center justify-center px-6 pt-20">
      <div className="w-full max-w-md rounded-3xl border border-olive/10 bg-white p-8 shadow-sm">
        <div className="mb-6 flex flex-col items-center text-center">
          <span className="mb-3 flex h-14 w-14 items-center justify-center rounded-full bg-olive text-ivory"><Wheat className="h-7 w-7" /></span>
          <h1 className="font-display text-2xl font-bold text-ink">{mode === "login" ? "تسجيل الدخول" : "إنشاء حساب"}</h1>
          <p className="mt-1 text-sm text-ink/55">إلى سهول جنين — جودة من أرضنا</p>
        </div>
        <form onSubmit={submit} className="space-y-4">
          {mode === "register" && (
            <Field label="الاسم" testid="auth-name" value={form.name} onChange={(v) => setForm({ ...form, name: v })} />
          )}
          <Field label="البريد الإلكتروني" type="email" testid="auth-email" value={form.email} onChange={(v) => setForm({ ...form, email: v })} />
          <Field label="كلمة المرور" type="password" testid="auth-password" value={form.password} onChange={(v) => setForm({ ...form, password: v })} />
          <button data-testid="auth-submit" type="submit" disabled={busy}
            className="btn-shine w-full rounded-full bg-olive py-3.5 font-semibold text-ivory transition-colors hover:bg-olive-dark disabled:opacity-60">
            {busy ? "لحظات..." : mode === "login" ? "دخول" : "إنشاء الحساب"}
          </button>
        </form>
        <div className="mt-5 text-center text-sm text-ink/60">
          {mode === "login" ? "ليس لديك حساب؟" : "لديك حساب؟"}{" "}
          <button data-testid="auth-switch" onClick={() => setMode(mode === "login" ? "register" : "login")} className="font-medium text-olive link-underline">
            {mode === "login" ? "أنشئ حساباً" : "سجّل الدخول"}
          </button>
        </div>
        <Link to="/" className="mt-4 block text-center text-xs text-ink/40">العودة للرئيسية</Link>
      </div>
    </div>
  );
}

const Field = ({ label, value, onChange, type = "text", testid }) => (
  <div>
    <label className="mb-1.5 block text-sm text-ink/60">{label}</label>
    <input data-testid={testid} type={type} value={value} onChange={(e) => onChange(e.target.value)}
      className="w-full rounded-xl border border-olive/20 bg-white px-4 py-3 outline-none focus:border-olive" required />
  </div>
);
